<template>
  <a-row>
    <a-row class="content-title" type="flex">
      <h2>Баннеры</h2>
      <a-button
        style="margin-left: auto"
        type="primary"
        @click="$router.push({ name: 'banners-create' })"
      >
        <a-icon type="plus" />Добавить
      </a-button>
    </a-row>
    <a-table
      :columns="columns"
      :data-source="list"
      :loading="loading"
      :pagination="{ defaultPageSize: 10 }"
      :row-key="(rec) => rec.id"
    >
      <template slot="banner_href" slot-scope="item">
        <router-link
          :to="{ name: 'banners-id', params: { id: item.id } }"
          class="td-post-item"
          tag="span"
        >
          {{ item.link[$i18n.locale] || "Не заполнено" }}
        </router-link>
      </template>

      <template slot="operation" slot-scope="item">
        <a-icon
          class="action-btns"
          type="edit"
          @click="
            $router.push({
              name: 'banners-id',
              params: { id: item.id }
            })
          "
        />
        <a-popconfirm
          title="Вы действительно хотите удалить?"
          cancel-text="Нет"
          ok-text="Да"
        >
          <!-- @confirm="" -->
          <a-icon class="action-btns" style="margin: 0 10px" type="delete" />
        </a-popconfirm>
      </template>
    </a-table>
  </a-row>
</template>

<script>
import { mapState, mapActions } from "vuex"
export default {
  computed: {
    ...mapState({
      list: (state) => state.banners.results || [],
      count: (state) => state.banners.items_count || 0,
      loading: (state) => state.banners.loading
    }),

    columns() {
      return [
        {
          title: "Ссылка баннера",
          key: "name",
          scopedSlots: { customRender: "banner_href" }
        },
        {
          title: "Действие",
          key: "operation",
          width: "10%",
          scopedSlots: { customRender: "operation" }
        }
      ]
    }
  },

  mounted() {
    this.fetch(this.defaultPaginationProps)
  },

  methods: {
    ...mapActions("banners", ["fetch"])
  }
}
</script>
